

























































































































































































import axios from 'axios';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoUser from '@/components/Molecules/co-user/CoUser.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import { AccessIdentity } from '@/types/AccessIdenitity';
import CoSkeleton from '@/components/Atoms/co-skeleton/CoSkeleton.vue';
import { get, startCase, toLower } from 'lodash';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import { AccessTag } from '@/types/AccessTag';
import { AccessPolicy } from '@/types/AccessPolicy';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';

export default {
    name: 'AccessIdentityCreateEdit',
    emits: [
        'identity-created',
        'identity-updated',
        'identity-deleted',
        'identity-create-error',
        'identity-update-error',
        'identity-delete-error',
    ],
    components: {
        CoInput,
        CoFormGroup,
        CoUser,
        CoRoundButton,
        CoSkeleton,
        CoConfirmation,
    },
    props: {
        identity: {
            type: Object as () => AccessIdentity,
            default: () => ({} as AccessIdentity),
            required: false,
        },
        disableUserSelection: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectedUser: null,
            form: {} as AccessIdentity,
            loading: false,
            creatingOrUpdating: false,
            from: null,
            to: null,
            tags: [] as AccessTag[],
            policies: [] as AccessPolicy[],

            allPolicies: [] as AccessPolicy[], // This will hold all available policies
        };
    },
    watch: {
        identity: {
            handler(newValue) {
                this.mapIdentityToDataVaribles(newValue);
            },
            deep: true,
        },
        selectedUser: {
            handler(newValue) {
                if (newValue) {
                    this.form.UserID = newValue.ID;
                    this.form.FirstName = newValue.Profile?.FirstName || '';
                    this.form.LastName = newValue.Profile?.LastName || '';
                    this.form.Email = newValue.Email || '';
                    this.form.DisplayName =
                        newValue.Profile?.Name || `${newValue.Profile?.FirstName} ${newValue.Profile?.LastName}`;
                }
            },
            deep: true,
        },
    },
    computed: {
        canISave() {
            return this.selectedUser && this.tags.length > 0;
        },
    },
    mounted() {
        this.loading = true;
        this.listPolicies()
            .then((policies) => {
                this.allPolicies = policies;
            })
            .catch((error) => {
                console.error('Error fetching policies:', error);
            })
            .finally(() => {
                this.loading = false;
            });

        this.mapIdentityToDataVaribles(this.identity);
    },
    methods: {
        startCase,
        toLower,

        deleteAccess() {
            this.creatingOrUpdating = true;
            axios({
                method: 'DELETE',
                url: `/admin/space/access/identity/${this.identity.ID}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(() => {
                    this.$emit('identity-deleted', this.identity);
                })
                .catch((error) => {
                    this.$emit('identity-delete-error', error);
                })
                .finally(() => {
                    this.creatingOrUpdating = false;
                });
        },
        mapIdentityToDataVaribles(identity: AccessIdentity) {
            if (!identity) {
                return;
            }

            this.form = { ...identity };
            this.from = new Date(identity.ValidFrom || new Date()).toISOString().split('T')[0];
            this.to = new Date(identity.ValidTo || new Date(new Date().setFullYear(new Date().getFullYear() + 10)))
                .toISOString()
                .split('T')[0];

            if (identity.UserID) {
                this.getUserByID(identity.UserID)
                    .then((user) => {
                        this.selectedUser = user || null;
                    })
                    .catch((error) => {
                        console.error('Error fetching user:', error);
                    });
            }
            if (identity.Tags) {
                this.tags = [...identity.Tags];
            }
            if (identity.Policies) {
                this.policies = [...identity.Policies];
            }
        },

        selectUser(user) {
            const usrObj = user?.value?.object || {};
            this.selectedUser = usrObj;
            this.form.UserID = usrObj?.ID || null;
            this.form.FirstName = usrObj?.Profile?.FirstName || '';
            this.form.LastName = usrObj?.Profile?.LastName || '';
            this.form.Email = usrObj?.Email || '';
            this.form.DisplayName =
                usrObj?.Profile?.Name || `${usrObj?.Profile?.FirstName} ${usrObj?.Profile?.LastName}` || '';
        },
        unselectUserFor() {
            this.selectedUser = null;
            this.form.UserID = null;
            this.form.FirstName = '';
            this.form.LastName = '';
            this.form.Email = '';
            this.form.DisplayName = '';
        },
        removeAccessPolicy(policy) {
            this.policies = this.policies.filter((p) => p.ID !== policy.ID);
        },
        selectAccessPolicy(policy) {
            this.policies.push(policy.value);
        },
        selectAccessTag(tag) {
            this.tags.push(tag.value);
        },
        removeAccessTag(tag) {
            this.tags = this.tags.filter((t) => t.ID !== tag.ID);
        },
        searchAccessPolicy(e) {
            // filter policies based on search term
            const searchTerm = e.toLowerCase();
            const policies = this.allPolicies.filter((policy) => policy.Name.toLowerCase().includes(searchTerm));

            // filter out already selected policies
            const selectedPolicyIDs = this.policies.map((p) => p.ID);
            const filteredPolicies = policies.filter((p) => !selectedPolicyIDs.includes(p.ID));

            return filteredPolicies.map((policy) => ({
                label: policy.Name,
                value: policy,
            }));
        },
        searchAccessTags(e) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'GET',
                    url: `/admin/space/access/tag/search/${e}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then((response) => {
                        resolve(
                            get(response, 'data.Tags', []).map((i) => ({
                                label: i.Name,
                                value: i,
                            }))
                        );
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        searchUsers(e) {
            return new Promise((resolve, reject) => {
                if (e.length < 2) {
                    resolve([]);
                    return true;
                }
                axios({
                    method: 'GET',
                    url: `/admin/member/search/${e}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then((response) => {
                        resolve(
                            get(response, 'data.objects', []).map((i) =>
                                // map user to Suggestion type
                                ({
                                    label:
                                        i?.object?.Profile?.Name ||
                                        `${i?.object?.Profile?.FirstName} ${i?.object?.Profile?.LastName}` ||
                                        '',
                                    thumbnail: i?.object?.Profile?.ImageURL || '',
                                    value: i,
                                })
                            )
                        );
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getUserByID(id) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                axios({
                    method: 'GET',
                    url: `/admin/community/member/${id}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then((response) => {
                        resolve(get(response, 'data', {}));
                    })
                    .catch((error) => {
                        reject(error);
                        this.loading = false;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            });
        },
        prepareFromToSumbit() {
            this.form.Tags = this.tags;
            this.form.Policies = this.policies;
            this.form.ValidFrom = Date.parse(this.from);
            this.form.ValidTo = Date.parse(this.to);
            this.form.UserID = this.selectedUser?.ID || null;
        },
        createOrUpdate() {
            this.creatingOrUpdating = true;
            this.prepareFromToSumbit();
            if (this.identity?.ID) {
                axios({
                    method: 'PUT',
                    url: '/admin/space/access/identity',
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: this.form,
                })
                    .then((response) => {
                        this.$emit('identity-updated', get(response, 'data', {}));
                    })
                    .catch((error) => {
                        this.$emit('identity-update-error', error);
                    })
                    .finally(() => {
                        this.creatingOrUpdating = false;
                    });
            } else {
                axios({
                    method: 'POST',
                    url: '/admin/space/access/identity',
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: this.form,
                })
                    .then((response) => {
                        this.$emit('identity-created', get(response, 'data', {}));
                        this.$emit('identity-updated', get(response, 'data', {}));
                    })
                    .catch((error) => {
                        this.$emit('identity-create-error', error);
                    })
                    .finally(() => {
                        this.creatingOrUpdating = false;
                    });
            }
        },
        listPolicies() {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'GET',
                    url: '/admin/space/access/policy/list',
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then((response) => {
                        this.allPolicies = get(response, 'data', []);
                        resolve(this.allPolicies);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
